import { SupplierAccountRequest } from './../models/supplier-account-request';
import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
const addSupplierAccountRequestMutation = gql`mutation add_supplier_account_request($supplier_account_request: supplier_account_requests_insert_input!){
  insert_supplier_account_requests_one(object: $supplier_account_request){
    id
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class AddSupplierAccountRequestService {
  /* ------------------------------- Constructor ------------------------------ */
  constructor(private apollo: Apollo) { }
  /* ------------------------ addSupplierAccountRequest ----------------------- */
  addSupplierAccountRequest(supplier_account_request: SupplierAccountRequest): Promise<any> {
    return this.apollo.use('external').mutate({
      mutation: addSupplierAccountRequestMutation,
      variables: {
        supplier_account_request
      }
    }).toPromise();
  }
}
